import { Team } from 'models/team';
import { User } from 'models/user';
import { getQueryArray } from 'utils/helpers/getQueryArray';

import { api } from '..';
import {
  AddTeam,
  AddUsersInTeam,
  DeleteUsersFromTeam,
  EditTeam,
  FetchOneTeam,
  FetchTeamsParams,
} from './teams';
import { FetchWithPagination } from '../common';
import { FetchUsers } from '../users/users';

export const teamsApi = api.injectEndpoints({
  endpoints: (build) => ({
    fetchTeams: build.query<FetchWithPagination<Team[]>, FetchTeamsParams>({
      query: (params) => ({
        url: '/teams',
        params,
      }),
      providesTags: ['Teams'],
    }),
    addTeam: build.mutation<Team, AddTeam>({
      query: (body) => ({
        url: '/teams',
        method: 'POST',
        body,
      }),
      transformResponse: (rawResult: { data: Team }) => {
        return rawResult.data;
      },
      invalidatesTags: ['Teams', 'User'],
    }),
    fetchOneTeam: build.query<Team, FetchOneTeam>({
      query: (id) => `/teams/${id}`,
      transformResponse: (rawResult: { data: Team }) => {
        return rawResult.data;
      },
      providesTags: ['Teams'],
    }),
    updateTeam: build.mutation<Team, EditTeam>({
      query: ({ teamId, ...body }) => {
        return {
          url: `/teams/${teamId}`,
          method: 'PATCH',
          body,
        };
      },
      transformResponse: (rawResult: { data: Team }) => {
        return rawResult.data;
      },
      invalidatesTags: ['Teams', 'Users', 'User'],
    }),
    fetchUsersInTeam: build.query<FetchWithPagination<User[]>, FetchUsers & { id: number }>({
      query: ({ id, roles, statuses, ...params }) => {
        const parsedRoles = getQueryArray(roles, 'roles');
        const parsedStatuses = statuses
          ? getQueryArray(statuses, 'statuses')
          : getQueryArray(['ACTIVE'], 'statuses');
        return {
          url: `/teams/${id}/users?${parsedRoles}&${parsedStatuses}`,
          params,
        };
      },
      providesTags: ['Users'],
    }),
    deleteUsersFromTeam: build.mutation<void, DeleteUsersFromTeam>({
      query: (body) => ({
        url: `/teams/${body.teamId}/users`,
        method: 'DELETE',
        body: { usersIds: body.usersToDelete },
      }),
      invalidatesTags: ['Teams', 'Users', 'User'],
    }),
    addUsersInTeam: build.mutation<void, AddUsersInTeam>({
      query: (body) => ({
        url: `/teams/${body.teamId}/users`,
        method: 'POST',
        body: { usersIds: body.usersToAdd },
      }),
      invalidatesTags: ['Teams', 'Users'],
    }),
  }),
});
